<template v-if="user.permissions">
    <div class="home__container">
        <h1><span>{{ $t('home.TITLE') }}</span> {{ $t('global.TITLE') }}</h1>
        <!-- <div class="carousel__container" >
            <carousel :wrapAround="true"  :autoplay="5000" >
                <slide v-for="image in slides" v-bind:key="image" >
                    <img :src="image"/>
                </slide>
    
                <template #addons="{ slidesCount }" >
                    <navigation v-if="slidesCount > 1" />
                </template>
            </carousel>
        </div> -->
        <template v-if="user?.permissions?.includes('CURSO_VER_PROPIOS')">
            <h3>{{ $t('home.COURSES') }}</h3>

            <div class="course__home__container">
                <template v-if="!coursesLoaded" >
                    <CourseCard :loader="coursesLoaded" />
                    <CourseCard :loader="coursesLoaded" />
                    <CourseCard :loader="coursesLoaded" />
                </template>
                <InformationRectangle 
                        icon="class" 
                        title="No tienes cursos en progreso" 
                        message="Cuando inicies un curso, lo encontrarás aquí" 
                        background="#ffddd7" 
                        color="#F57055"
                        v-if="!courses?.totalResults && coursesLoaded" 
                    />
                <template v-for="course in courses?.data" :key="course.id" >
                    <CourseCard :loader="coursesLoaded" :course="course" />
                </template>
            </div>
        </template>

        <template v-if="!(user.role?.toLowerCase() === 'learninguser' && user.type?.toLowerCase() === 'joven')">
            <div class="resources-title" >
                <h3>{{ $t('home.RESOURCES') }}</h3>
                <span @click="router.push('/resources')" >Ver todos <i class="material-icons-outlined">arrow_forward</i></span>
            </div>
    
            <div class="resources__home__container" >
                <template v-if="!resourcesLoaded" >
                    <ResourceCard :loader="resourcesLoaded" />
                    <ResourceCard :loader="resourcesLoaded" />
                    <ResourceCard :loader="resourcesLoaded" />
                </template>
                <template v-for="resource in resources" :key="resource.id" >
                    <ResourceCard :resource="resource" :loader="resourcesLoaded" />
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    import CourseCard from '../components/CourseCard.vue'
    import ResourceCard from '../components/ResourceCard.vue'
    import { useStore } from 'vuex';
    import { ref, inject, computed } from 'vue'
    // import { Carousel, Slide, Navigation } from 'vue3-carousel'

    // import { useRouter } from 'vue-router';
    // import { useRoute } from 'vue-router';
    import 'vue3-carousel/dist/carousel.css'
    import { onMounted } from 'vue-demi'
import { useRouter } from 'vue-router';
import InformationRectangle from '../components/InformationRectangle.vue';
    export default {
        components: {
    CourseCard,
    ResourceCard,
    InformationRectangle
},
        setup(){
            const store = useStore();
            const router = useRouter()
            const courses = ref();
            const resources = ref();
            const coursesLoaded = ref(false)
            const resourcesLoaded = ref(false)
            const formatDate = inject('formatDate');
            const homeTitle = ref("")
            const user = computed(() => store.getters.manageUser_user);

            async function getCourses() {
                const req = await store.dispatch("courses_actives", {rowsPerPage: 4, pageNumber: 0, userId: ''})
                courses.value = req.data
                courses.value.data?.forEach(course => course.image !== null && course.image.replace('.png', '_thumb.png'))
                coursesLoaded.value = true
            }

            async function getResources () {
                let req = await store.dispatch("random_resources")
                resources.value = req.data
                resources.value.forEach( r => {
                    r.data = JSON.parse(r.data)
                });
                resourcesLoaded.value = true
            }

            onMounted(() => {
                if(user.value.permissions === undefined) router.replace('/login')
                if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
                    homeTitle.value = "<span>Te damos la bienvenida a</span> Learning Community";
                }
                else
                {
                    homeTitle.value = "<span>Te damos la bienvenida a </span>Experiencias educativas";
                }
                getCourses()
                getResources()
            })

            return {
                coursesLoaded,
                formatDate,
                courses,
                resourcesLoaded,
                resources,
                router,
                homeTitle,
                user
            }
        }
    }
</script>

<style lang="scss">
@import "@/styles/main.scss";
@import "../../node_modules/vue3-carousel/dist/carousel.css";

.home__container{
    --vc-nav-background-color: #fff;
    --vc-nav-width: 40px;
    background-color: #fff;
    padding: 30px 0;
    //min-height: 700px;
    width: 1328px;
    margin: 0 auto;
    @media screen and (max-width: 1400px){
        width: 992px;
    }
    @media screen and (max-width: 1100px){
        width: 656px;
    }
    @media screen and (max-width: 700px){
        width: 98%;
    }
    h1 {
        font-size: 28px;
        font-weight: 700;
        span{
            font-weight: 400;
        }
    }
    h3 {
        font-size: 24px;
        font-weight: 700;
        color: $black;
        margin: 22px 0;
    }
}

.resources-title{
    display: flex;
    align-items: center;
    gap: 24px;
    @media screen and (max-width: $bpSmall){
        gap: 6px;
    }
    span{
        color: $green;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        font-weight: 600;   
        @media screen and (max-width: $bpSmall){
            gap: 8px;
        }
        cursor: pointer;
        .material-icons-outlined{
            font-size: 18px;
        }
    }
}

.course__home__container, .resources__home__container{
    display: flex;
    gap: 16px;
}
.course__home__container{
    padding-bottom: 16px;
    overflow-x: auto;
    &::-webkit-scrollbar-track {
        border-radius: 100px;
        background-color: rgba(0,0,0,.1);
    }
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background-color: transparent;
        margin: 4px 0;
    }
    &::-webkit-scrollbar-thumb {
        border-radius: 100px;
        background: map-get($dark, 400);
        position: absolute;
    }
}
.resources__home__container{
    @media screen and (min-width: $bpBig) and (max-width: 1400px){
        .resourceCard:last-child{
            display: none;
        }
    }
    @media screen and (min-width: $bpMedium - 40px) and (max-width: $bpBig){
        /* .resourceCard:last-child, .resourceCard:nth-child(3){
            display: none;
        } */
        flex-wrap: wrap;
    }
    @media screen and (max-width: $bpMedium - 40px){
        flex-direction: column;
        align-items: flex-start;
    }
}

@media screen and (max-width: $bpMedium){
    .home__container{
        h1{
            font-size: 22px;
            text-align: center;
        }
        h3{
            padding-left: 12px;
            font-size: 15px;
        }
    }
    .course__home__container{
        display: flex;
        gap: 16px;
        flex-wrap: nowrap;
        margin: 0 6px;
        padding-bottom: 24px;
    }
}

/* .carousel__prev {
  top: 50%;
  left: 28px;
  transform: translate(-50%, -50%);
}
.carousel__next {
  top: 50%;
  right: 28px;
  transform: translate(50%, -50%);
}
.carousel__container{
    margin: 24px 0;
} */

</style>